import { Avatar as Avt, AvatarProps } from 'antd';
import React from 'react';

import { Knife } from '@utils/tool';

type Props = {
  content: string
  colorNum: number
} & AvatarProps

const colors = ['#b08181', '#8f8e73', '#8d6d54', '#c09c7a']

const Avatar = (props: Props) => {
  const { content, colorNum, ...rest } = props

  const color = React.useMemo(() => colors[colorNum], [])
  return (
    <Avt {...rest} style={{ backgroundColor: color }}>
      {content?.slice(0, 1)}
    </Avt>
  )
}

export default Avatar
